import { connect } from 'react-redux';
import React, { PropTypes } from 'react';
import { fetchSites } from '../actions/sites';
import { getSites } from '../reducers/sites';
import Site from './Site';
import { fetchForm, toggleTask, updateData } from '../actions/form';
import { getSiteDiagnosis } from '../reducers/form';
import { getIsDirty } from '../reducers/dirty';
import { fetchRequirements } from '../actions/requirements';
import {
  getAnnex1ComplexList,
  getAnnex1SimpleList1,
  getAnnex1SimpleList2,
  getAnnex2ComplexList,
  getAnnex2SimpleList1,
  getAnnex2SimpleList2,
  getAnnexConf,
  getContractTypes,
  getInfestationLevels,
  getInfraTypes,
  getInsectSpecies,
  getInsectTreatments,
  getOtherSpecies,
  getOtherTreatments,
  getRatSpecies,
  getTimeUnits,
  getPlacesRef,
  getAccessibilityRef,
} from '../reducers/requirements';
import { isFetching } from '../reducers/index';

export class Page extends React.Component {
  constructor(props) {
    super(props);
    this.state = { activeIndex: -1 };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e, titleProps) {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  }

  componentWillMount() {
    this.props.fetchRequirements(this.props.id);
    this.props.fetchSites(this.props.id);
    this.props.fetchForm(this.props.id);
  }

  render() {
    const valueChanged = siteId => (task, propName, propValue) => {
      this.props.updateData(siteId, task, propName, propValue);
    };

    const toggleSiteTask = siteId => task => {
      this.props.toggleTask(siteId, task);
    };

    const segments = sites =>
      sites.map((s, index) => (
        <Site
          key={s.id}
          site={s}
          startIndex={index * 10}
          handleClick={this.handleClick}
          activeIndex={this.state.activeIndex}
          onChange={valueChanged(s.id)}
          siteDiagnosis={this.props.getDiagnosis(s.id)}
          toggleTask={toggleSiteTask(s.id)}
          timeUnits={this.props.timeUnits}
          infestationLevels={this.props.infestationLevels}
          infraTypes={this.props.infraTypes}
          ratSpecies={this.props.ratSpecies}
          contractTypes={this.props.contractTypes}
          insectSpecies={this.props.insectSpecies}
          insectTreatments={this.props.insectTreatments}
          otherSpecies={this.props.otherSpecies}
          otherTreatments={this.props.otherTreatments}
          annexConf={this.props.annexConf}
          annex1SimpleList1={this.props.annex1SimpleList1}
          annex1SimpleList2={this.props.annex1SimpleList2}
          annex1ComplexList={this.props.annex1ComplexList}
          annex2SimpleList1={this.props.annex2SimpleList1}
          annex2SimpleList2={this.props.annex2SimpleList2}
          annex2ComplexList={this.props.annex2ComplexList}
          dirty={this.props.isDirty}
          placesRef={this.props.placesRef}
          accessibilityRef={this.props.accessibilityRef}
        />
      ));

    if (!this.props.isFetching) {
      return <div>{this.props.sites && segments(this.props.sites)}</div>;
    } else {
      return (
        <div
          className="ui active loading segment"
          style={{ minHeight: '180px' }}
        />
      );
    }
  }
}

Page.propTypes = {
  id: PropTypes.number.isRequired,
  customerId: PropTypes.number.isRequired,
  fetchSites: PropTypes.func.isRequired,
  sites: PropTypes.array.isRequired,
  fetchForm: PropTypes.func.isRequired,
  fetchRequirements: PropTypes.func.isRequired,
  getDiagnosis: PropTypes.func.isRequired,
  toggleTask: PropTypes.func.isRequired,
  timeUnits: PropTypes.array.isRequired,
  infestationLevels: PropTypes.array.isRequired,
  infraTypes: PropTypes.array.isRequired,
  ratSpecies: PropTypes.array.isRequired,
  contractTypes: PropTypes.array.isRequired,
  insectSpecies: PropTypes.array.isRequired,
  insectTreatments: PropTypes.array.isRequired,
  otherSpecies: PropTypes.array.isRequired,
  otherTreatments: PropTypes.array.isRequired,
  annexConf: PropTypes.object.isRequired,
  annex1SimpleList1: PropTypes.array.isRequired,
  annex1SimpleList2: PropTypes.array.isRequired,
  annex1ComplexList: PropTypes.array.isRequired,
  annex2SimpleList1: PropTypes.array.isRequired,
  annex2SimpleList2: PropTypes.array.isRequired,
  annex2ComplexList: PropTypes.array.isRequired,
  isFetching: PropTypes.bool.isRequired,
  isDirty: PropTypes.bool,
  placesRef: PropTypes.array.isRequired,
  accessibilityRef: PropTypes.array.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  sites: getSites(state),
  getDiagnosis: getSiteDiagnosis(state),
  timeUnits: getTimeUnits(state),
  infestationLevels: getInfestationLevels(state),
  infraTypes: getInfraTypes(state),
  ratSpecies: getRatSpecies(state),
  contractTypes: getContractTypes(state),
  insectSpecies: getInsectSpecies(state),
  insectTreatments: getInsectTreatments(state),
  otherSpecies: getOtherSpecies(state),
  otherTreatments: getOtherTreatments(state),
  annexConf: getAnnexConf(state),
  annex1SimpleList1: getAnnex1SimpleList1(state),
  annex1SimpleList2: getAnnex1SimpleList2(state),
  annex1ComplexList: getAnnex1ComplexList(state),
  annex2SimpleList1: getAnnex2SimpleList1(state),
  annex2SimpleList2: getAnnex2SimpleList2(state),
  annex2ComplexList: getAnnex2ComplexList(state),
  isFetching: isFetching(state),
  isDirty: getIsDirty(state),
  placesRef: getPlacesRef(state),
  accessibilityRef: getAccessibilityRef(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchSites: caseId => dispatch(fetchSites(caseId)),
  fetchRequirements: caseId => dispatch(fetchRequirements(caseId)),
  fetchForm: caseId => dispatch(fetchForm(caseId)),
  updateData: (siteId, task, propName, propValue) =>
    dispatch(updateData(siteId, task, propName, propValue)),
  toggleTask: (siteId, task) => dispatch(toggleTask(siteId, task)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Page);



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step2/components/Page.js